import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IStockMovement, IStockMovementInput } from "@/interfaces/sku-movement.interfaces";
import stockMovementService from "@/services/stock-movement.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateStockMovementProps = {
  formData: IStockMovementInput;
} & RequestsProps;

export type UseCreateStockMovementReturn = {
  create: (props: CreateStockMovementProps) => Promise<IStockMovement>;
} & UseLoadingReturn;

const useCreateStockMovement = (): UseCreateStockMovementReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<IStockMovementInput>({
      operation: (formData) => stockMovementService.create(formData),
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateStockMovement;
